const isDashboardTemplate = (
  dashboard: DashboardType | undefined,
): dashboard is DashboardTemplate => {
  return !!dashboard && !!dashboard.isTemplate;
};

export default isDashboardTemplate;
